<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4"> Сотрудник </v-card-title>
    <v-card-text>
      <div>
        <!-- :items="author.employeesList" -->
        {{ author }}

        <CardAutocompleteRow
          v-model="author"
          item-value="id"
          item-text="fullName"
          :items="authorsList"
          label="ФИО"
          placeholder="Введите не менее 3-х симовлов"
          return-object
          hide-no-data
          :disabled="isShowMode"
          :required="!isShowMode"
          :hide-border-bottom="true"
          @searchData="getEmployees($event, index)"
          @change="getEmployeePosition($event, index)"
        />
        <CardRow
          label="Кафедра"
          :hide-border-bottom="true"
        >
        </CardRow>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import CardAutocompleteRow from '@/components/ui/row/CardAutocompleteRow'
import CardFieldRow from '@/components/ui/row/CardFieldRow'
import CardRow from '@/components/ui/row/CardRow'
import _debounce from 'lodash/debounce'
import { employeePositionApi } from '@/api'
import { AuthorWorkParent, AuthorWork } from '@/models'
import { employeeApi } from '../../../api'
export default {
  name: 'EmployeeCard',
  props: {
    isShowMode: Boolean,
    selectedItem: Object
  },
  data: () => ({
    author: new AuthorWork(),
    authorsList: new AuthorWorkParent()
  }),
  components: {
    CardFieldRow,
    CardAutocompleteRow,
    CardRow
  },
  methods: {
    // getEmployees: _debounce(async function (val, index) {
    //   await this.authors.list[index]?.findEmployees(val)
    // }, 500),
    getEmployees: _debounce(async function (val) {
      const data = await employeeApi.findByName(val)
      this.authorsList = data
    }, 500),
    getEmployeePosition: _debounce(async function (employee, index) {
      if (employee) {
        try {
          this.authors.list[index].employeePositionsLoading = true
          let employeePositionList = await employeePositionApi.findAllByEmployee(employee.id)
          employeePositionList = employeePositionList?.filter(el => el.isActual)

          if (employeePositionList.length === 0) this.$toast.error('У выбранного автора отсутствует кафедра')
          else if (employeePositionList.length === 1)
            this.authors.list[index].employeePosition = employeePositionList[0]
          else this.authors.list[index].employeePositionsByEmployee = employeePositionList

          await this.updateAuthors()
        } catch (error) {
          console.log(error)
          this.showErrorMessage(error, 'Не удалось получить список подразделений')
        } finally {
          this.authors.list[index].employeePositionsLoading = false
        }
      }
    }, 10),
    async updateAuthors() {
      try {
        this.$emit('update:selected-item', new AuthorWorkParent(this.authors?.list))
        this.updateInvalid()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка при обновлении')
        throw e
      }
    }
  }
}
</script>
